export default __webpack_public_path__ + "static/media/error-fill.dc596c8a.svg";